import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaBrain, FaCode, FaCloud, FaChartLine, FaHeadset, FaPlug, FaBook, FaUserCog, FaChalkboard, FaSync, FaDesktop, FaReact } from 'react-icons/fa';
import { FaHtml5 } from "react-icons/fa6";

// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Category Icons -----*/
    case 'landing pages':
      return <FaDesktop />; // Line chart icon

    case 'html templates':
      return <FaHtml5 />; // Code icon (HTML/CSS)

    case 'react templates':
      return <FaReact />; // React logo icon

    /*----- Service Icons -----*/
    case 'html template':
      return <FaCode />; // Code icon (HTML/CSS)

    case 'react template':
      return <FaReact />; // React logo icon

    case 'landing page':
      return <FaDesktop />; // Page/document icon

    case 'portfolio templates':
      return <FaUserTie />; // Professional/portfolio icon

    case 'business templates':
      return <FaBriefcase />; // Business icon

    case 'ongoing support':
      return <FaHeadset />; // Support icon


    /*----- Support Button Icons -----*/
    case 'ai support':
      return <FaBrain />; // Brain icon

    case 'cloud services':
      return <FaCloud />; // Cloud icon

    case 'data analytics':
      return <FaChartLine />; // Chart line icon

    case 'integration issues':
      return <FaPlug />; // Plug icon

    case 'support docs':
      return <FaBook />; // Book icon

    case 'account management':
      return <FaUserCog />; // User settings icon

    case 'ai training':
      return <FaChalkboard />; // Chalkboard icon

    case 'tech updates':
      return <FaSync />; // Sync icon


    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'time':
    case 'timing':
    case 'hours':
    case 'duration':
      return <FaClock />; // Clock icon

    case 'beneficiaries':
    case 'position':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'cost':
    case 'salary':
    case 'fee':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'projectlead':
    case 'organizer':
      return <FaUserTie />; // User Tie icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    default:
      return null; // No matching icon

  }

};